/**
 * Definition of the DownloadUtil instance.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025-2026
 */

import { getDownloadUtil } from '@amplify3/duplo-back-end'
import { baseURL } from './env'
export const downloader = getDownloadUtil(baseURL)
